import { Card, CardContent } from "../../card";
import { MarkdownProse } from "../markdown-prose";

export interface HelpArticleBodyProps {
  body_md: string;
}

/**
 * Renders an article's markdown body inside a Card. Uses the same
 * `<MarkdownProse>` renderer the /document product uses — no new
 * markdown library.
 */
export function HelpArticleBody({ body_md }: HelpArticleBodyProps) {
  return (
    <Card>
      <CardContent>
        <MarkdownProse content={body_md} />
      </CardContent>
    </Card>
  );
}
